<template lang="pug">
#layout(:class='className')
  .wrapper.centered(:class="{ 'nav-open' : navOpened }")
    sidebar(:open='navOpened')
    .main-panel(:class="{ 'loading' : loading }")
      ed-meta-nav
      navigation(@toggleSideBar='toggleSideBar')
      slot
      md-footer
      .close-layer(v-if='navOpened', @click='onCloseLayerClick')
</template>

<script>

import MainLayout from './main'

export default {
  extends: MainLayout,
  computed: {
    className: function () {
      return 'layout-other ' + (this.$route.params.section ? 'scoped' : '')
    }
  }
}

</script>



// WEBPACK FOOTER //
// other.vue?c570f42e